export const privacy = {
  // SEO
  title: 'Politique de Confidentialité - KiraCar',
  description: 'Découvrez comment KiraCar protège votre vie privée et gère vos données personnelles. Notre politique de confidentialité complète couvre la collecte de données, l\'utilisation et vos droits.',
  keywords: 'politique de confidentialité, protection des données, RGPD, données personnelles, KiraCar, location de voiture, droits à la vie privée',
  
  // Hero Section
  heroTitle: 'Politique de Confidentialité',
  heroDescription: 'Votre vie privée est importante pour nous. Cette politique explique comment nous collectons, utilisons et protégeons vos informations.',
  lastUpdated: 'Dernière mise à jour',
  
  // Sections
  introduction: {
    title: 'Introduction',
    paragraph1: 'KiraCar (« nous », « notre » ou « nos ») s\'engage à protéger votre vie privée. Cette Politique de Confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous utilisez notre plateforme de location de voitures et nos services.',
    paragraph2: 'En utilisant nos services, vous acceptez la collecte et l\'utilisation d\'informations conformément à cette politique. Si vous n\'êtes pas d\'accord avec nos politiques et pratiques, veuillez ne pas utiliser nos services.'
  },
  
  informationWeCollect: {
    title: 'Informations que Nous Collectons',
    personalInformation: {
      title: 'Informations Personnelles',
      accountInfo: {
        title: 'Informations de Compte',
        description: 'Nom, adresse e-mail, numéro de téléphone, date de naissance, photo de profil'
      },
      identityDocs: {
        title: 'Documents d\'Identité',
        description: 'Permis de conduire, passeport, carte d\'identité, permis de séjour'
      },
      locationData: {
        title: 'Données de Localisation',
        description: 'Lieux de prise en charge et de retour, coordonnées GPS, informations d\'adresse'
      }
    },
    bookingInformation: {
      title: 'Informations de Réservation',
      rentalDetails: {
        title: 'Détails de Location',
        description: 'Dates de prise en charge et de retour, préférences de véhicule, durée de location, informations tarifaires'
      },
      paymentInfo: {
        title: 'Informations de Paiement',
        description: 'Détails de la méthode de paiement, historique des transactions, adresse de facturation (traité de manière sécurisée via des fournisseurs tiers)'
      }
    },
    technicalInformation: {
      title: 'Informations Techniques',
      usageData: {
        title: 'Données d\'Utilisation',
        description: 'Adresse IP, type de navigateur, informations sur l\'appareil, système d\'exploitation, pages visitées, temps passé sur le site'
      },
      cookies: {
        title: 'Cookies et Suivi',
        description: 'Cookies de session, cookies de préférence, cookies d\'analyse, cookies marketing'
      }
    }
  },
  
  howWeUse: {
    title: 'Comment Nous Utilisons Vos Informations',
    serviceDelivery: {
      badge: 'Livraison de Service',
      title: 'Fournir Nos Services',
      description: 'Traiter les réservations, gérer les locations, gérer les paiements, fournir le support client'
    },
    communication: {
      badge: 'Communication',
      title: 'Communication',
      description: 'Envoyer des confirmations de réservation, des rappels de location, des mises à jour de service, des communications marketing (avec consentement)'
    },
    security: {
      badge: 'Sécurité',
      title: 'Sécurité et Prévention de la Fraude',
      description: 'Vérifier l\'identité, prévenir la fraude, assurer la sécurité de la plateforme, se conformer aux exigences légales'
    },
    improvement: {
      badge: 'Amélioration',
      title: 'Amélioration du Service',
      description: 'Analyser les modèles d\'utilisation, améliorer l\'expérience utilisateur, développer de nouvelles fonctionnalités, mener des recherches'
    },
    legal: {
      badge: 'Légal',
      title: 'Conformité Légale',
      description: 'Se conformer aux lois applicables, répondre aux demandes légales, protéger nos droits et intérêts'
    }
  },
  
  informationSharing: {
    title: 'Partage d\'Informations',
    intro: 'Nous ne vendons, n\'échangeons ni ne louons vos informations personnelles à des tiers. Nous ne pouvons partager vos informations que dans les circonstances suivantes :',
    serviceProviders: {
      badge: 'Fournisseurs de Services',
      title: 'Fournisseurs de Services de Confiance',
      description: 'Processeurs de paiement, services de messagerie, fournisseurs d\'analyse, fournisseurs de stockage cloud (sous des accords stricts de protection des données)'
    },
    businessPartners: {
      badge: 'Partenaires Commerciaux',
      title: 'Partenaires Commerciaux',
      description: 'Agences de location de voitures, fournisseurs d\'assurance, services de maintenance (uniquement les informations nécessaires à la prestation de services)'
    },
    legalRequirements: {
      badge: 'Exigences Légales',
      title: 'Exigences Légales',
      description: 'Lorsque requis par la loi, ordonnance du tribunal ou demande gouvernementale'
    },
    safety: {
      badge: 'Sécurité',
      title: 'Sécurité et Sûreté',
      description: 'Pour protéger nos utilisateurs, prévenir la fraude ou assurer la sécurité de la plateforme'
    }
  },
  
  dataSecurity: {
    title: 'Sécurité des Données',
    intro: 'Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos informations personnelles :',
    encryption: {
      title: 'Chiffrement',
      description: 'Toutes les données sont chiffrées en transit et au repos à l\'aide de protocoles de chiffrement standard de l\'industrie'
    },
    accessControls: {
      title: 'Contrôles d\'Accès',
      description: 'Des contrôles d\'accès stricts et des mécanismes d\'authentification limitent qui peut accéder à vos données'
    },
    regularAudits: {
      title: 'Audits Réguliers',
      description: 'Audits de sécurité réguliers et évaluations des vulnérabilités pour identifier et résoudre les risques potentiels'
    },
    secureInfrastructure: {
      title: 'Infrastructure Sécurisée',
      description: 'Hébergé sur une infrastructure cloud sécurisée et conforme avec des sauvegardes et une surveillance régulières'
    }
  },
  
  yourRights: {
    title: 'Vos Droits à la Vie Privée',
    intro: 'Vous disposez des droits suivants concernant vos informations personnelles :',
    access: {
      badge: 'Accès',
      title: 'Droit d\'Accès',
      description: 'Demander une copie des informations personnelles que nous détenons sur vous'
    },
    correction: {
      badge: 'Correction',
      title: 'Droit de Rectification',
      description: 'Demander la correction d\'informations personnelles inexactes ou incomplètes'
    },
    deletion: {
      badge: 'Suppression',
      title: 'Droit à la Suppression',
      description: 'Demander la suppression de vos informations personnelles (sous réserve d\'obligations légales et contractuelles)'
    },
    portability: {
      badge: 'Portabilité',
      title: 'Droit à la Portabilité des Données',
      description: 'Demander le transfert de vos données à un autre fournisseur de services'
    },
    objection: {
      badge: 'Opposition',
      title: 'Droit d\'Opposition',
      description: 'Vous opposer au traitement de vos informations personnelles à certaines fins'
    },
    withdraw: {
      badge: 'Retirer',
      title: 'Droit de Retirer le Consentement',
      description: 'Retirer le consentement pour le traitement basé sur le consentement à tout moment'
    }
  },
  
  cookies: {
    title: 'Cookies et Technologies de Suivi',
    intro: 'Nous utilisons des cookies et des technologies de suivi similaires pour améliorer votre expérience :',
    essential: {
      badge: 'Essentiel',
      title: 'Cookies Essentiels',
      description: 'Nécessaires pour les fonctionnalités de base du site web, l\'authentification et la sécurité'
    },
    analytics: {
      badge: 'Analyse',
      title: 'Cookies d\'Analyse',
      description: 'Nous aident à comprendre comment vous utilisez notre site web pour améliorer nos services'
    },
    preferences: {
      badge: 'Préférences',
      title: 'Cookies de Préférence',
      description: 'Mémorisent vos paramètres et préférences pour une expérience personnalisée'
    },
    marketing: {
      badge: 'Marketing',
      title: 'Cookies Marketing',
      description: 'Utilisés pour diffuser des publicités pertinentes et mesurer l\'efficacité des campagnes (avec consentement)'
    }
  },
  
  dataRetention: {
    title: 'Conservation des Données',
    intro: 'Nous conservons vos informations personnelles uniquement aussi longtemps que nécessaire pour remplir les objectifs décrits dans cette politique :',
    accountData: {
      badge: 'Données de Compte',
      title: 'Informations de Compte',
      description: 'Conservées pendant que votre compte est actif et pendant 3 ans après la fermeture du compte à des fins légales et commerciales'
    },
    bookingData: {
      badge: 'Données de Réservation',
      title: 'Dossiers de Réservation',
      description: 'Conservés pendant 7 ans à des fins comptables, légales et de résolution de litiges'
    },
    marketingData: {
      badge: 'Données Marketing',
      title: 'Communications Marketing',
      description: 'Conservées jusqu\'à ce que vous vous désinscriviez ou retiriez votre consentement'
    },
    analyticsData: {
      badge: 'Données d\'Analyse',
      title: 'Données d\'Analyse',
      description: 'Anonymisées et conservées jusqu\'à 2 ans pour l\'amélioration du service'
    }
  },
  
  internationalTransfers: {
    title: 'Transferts Internationaux de Données',
    intro: 'Vos informations personnelles peuvent être transférées et traitées dans des pays autres que votre pays de résidence. Nous nous assurons que des garanties appropriées sont en place :',
    adequacy: {
      badge: 'Adéquation',
      title: 'Décisions d\'Adéquation',
      description: 'Transferts vers des pays dotés de lois adéquates en matière de protection des données'
    },
    sccs: {
      badge: 'CCN',
      title: 'Clauses Contractuelles Types',
      description: 'Clauses contractuelles approuvées par l\'UE pour les transferts internationaux'
    },
    certification: {
      badge: 'Certification',
      title: 'Schémas de Certification',
      description: 'Participation à des schémas de certification reconnus en matière de protection des données'
    }
  },
  
  childrenPrivacy: {
    title: 'Vie Privée des Enfants',
    intro: 'Nos services ne sont pas destinés aux enfants de moins de 18 ans. Nous ne collectons pas sciemment d\'informations personnelles auprès d\'enfants de moins de 18 ans. Si vous êtes un parent ou un tuteur et que vous croyez que votre enfant nous a fourni des informations personnelles, veuillez nous contacter immédiatement.',
    importantNotice: {
      title: 'Avis Important',
      description: 'Si nous découvrons que nous avons collecté des informations personnelles auprès d\'un enfant de moins de 18 ans, nous supprimerons ces informations immédiatement.'
    }
  },
  
  contactUs: {
    title: 'Nous Contacter',
    intro: 'Si vous avez des questions concernant cette Politique de Confidentialité ou nos pratiques en matière de données, veuillez nous contacter :',
    email: 'E-mail',
    phone: 'Téléphone',
    address: 'Adresse',
    addressLine1: 'KiraCar',
    addressLine2: 'Maroc',
    addressLine3: 'Casablanca, Maroc'
  },
  
  changesToPolicy: {
    title: 'Modifications de Cette Politique',
    intro: 'Nous pouvons mettre à jour cette Politique de Confidentialité de temps à autre. Nous vous informerons de tout changement par :',
    notification: {
      badge: 'Notification',
      title: 'Notification par E-mail',
      description: 'Vous envoyer une notification par e-mail des changements importants'
    },
    website: {
      badge: 'Site Web',
      title: 'Avis sur le Site Web',
      description: 'Publier la politique mise à jour sur notre site web avec une nouvelle date de « Dernière mise à jour »'
    },
    inApp: {
      badge: 'Dans l\'App',
      title: 'Notification dans l\'Application',
      description: 'Afficher un avis dans notre application mobile ou sur notre site web'
    },
    yourRights: {
      title: 'Vos Droits',
      description: 'L\'utilisation continue de nos services après les modifications constitue une acceptation de la politique mise à jour. Vous pouvez retirer votre consentement à tout moment.'
    }
  },
  
  footer: {
    effectiveDate: 'Cette Politique de Confidentialité est entrée en vigueur le',
    lastUpdated: 'et a été mise à jour le',
    copyright: 'Tous droits réservés.'
  }
};
